import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import { AutheticationService } from "@app/shared/services/authetication.service";

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {

    constructor(private router: Router,
        private auth: AutheticationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .catch((res: any, caught) => {
                if (res instanceof HttpErrorResponse) {
                    if (res.status == 401 || res.error.code == 'not_allowed_ip'){
                        this.router.navigateByUrl('/login');
                        this.auth.logOut();
                    }
                    return Observable.throw(res);
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/Intercepters/auth-error.interceptor.ts